import React, { useState } from 'react';
import { Field } from 'react-final-form'

function MultiSelect(props: any) {
  
  const radioOptions = props.question.options?.split(/\r?\n/).map((opt: string) => ({label: opt, selected: false }))
  const [checkboxOptions, setCheckboxOptions] = useState(radioOptions);


  const toggleOptionSelection = (index: number, input: any) => {
    const cos = [...checkboxOptions]
    cos[index].selected = !cos[index].selected
    setCheckboxOptions(cos)

    const selectedOptions = checkboxOptions.filter((co: {label: string, selected: boolean}) => co.selected)
    const joinedAnswers = selectedOptions.map((co: {label: string, selected: boolean}) => co.label).join("\n")

    input.onChange(joinedAnswers)
  }

  const submitAnswer = (opt: string, input: any) => {
  	input.onChange(opt)

    props.moveToNext();
  }

  return (
	<Field
          name={`${props.baseName}[answer]`}
          render={({ input, meta }) => (
  	<>
  	{checkboxOptions.map((co: {label: string, selected: boolean}, index: number) =>
      <div key={index} className={`radio-button-option ${co.selected ? "selected" : ""}`} onClick={() => toggleOptionSelection(index, input)}>
          <div className="checkboxCircle"></div>
          {co.label}
      </div>
	 )}
    <button className="nextButton" onClick={props.moveToNext}>Next</button>

	</>
	)}
	/>
  );
}

export default MultiSelect;
